import Vue from "vue";
import App from "./App.vue";
import router from "./router";

import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
ElementUI.Input.props.clearable.default = true;
ElementUI.Select.props.clearable = { default: true };
Vue.use(ElementUI);

import countTo from "vue-count-to";
Vue.component("count-to", countTo);

Vue.config.productionTip = false;

import { Store } from "./store";
import { createPinia, PiniaVuePlugin } from "pinia";
// 创建pinia
Vue.use(PiniaVuePlugin);
const pinia = createPinia();
Vue.use(pinia);
// 全局绑定store
const store = Store();
Vue.prototype.$store = store;

// 引入全局api
import * as api from "./util/api";
Vue.prototype.$api = api.default;

// 筛选器
Vue.filter("handleTime", (time) => {
  if (!time) return "";
  return time.split(" ")[0];
});

new Vue({
  router,
  render: (h) => h(App),
}).$mount("#app");
